import dayjs from 'dayjs';

export const convertDateToText = (date, t) => {
  const today = dayjs().startOf('day');
  const targetDate = dayjs(date).startOf('day');
  const diffDays = targetDate.diff(today, 'day');

  if (diffDays === 0) {
    return t('general.today');
  } else if (diffDays === 1) {
    return t('general.tomorrow');
  } else if (diffDays > 1 && diffDays <= 7) {
    return t("days."+targetDate.format('dddd')); 
  } else {
    return targetDate.format('YYYY-MM-DD');
  }
};


  
export const getOccupancyColor = (percent, thresholds, lowColor = true) => {
  if (percent === 100) {
    return '#F44336';
  } else if (percent >= thresholds.high) {
    return '#FF9800';
  } else if (percent >= thresholds.medium) {
    return '#FFC107';
  } else if (lowColor) {
    return '#4CAF50';
  }
  return '';
};